import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductBundleItem, ProductBundleItemCreate, ProductBundleItemFilter } from '../data/productBundleItem';

export function createProductBundleItemService(client: AxiosInstance) {
  return createCrudService<ProductBundleItem, ProductBundleItemCreate, ProductBundleItemFilter>(
    client,
    '/master-data/ProductBundleItem',
    'id',
  );
}

export type ProductBundleItemService = CrudService<ProductBundleItem, ProductBundleItemCreate, ProductBundleItemFilter>;
